export default __webpack_public_path__ + "static/media/crusharmor4.b9d88098.png";